module.exports = __webpack_public_path__ + "static/media/Left Lateral Z2.680bb674.png";